require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-grange-residence-featured-in-vogue-living.json") })
        }
      }, "path---journal-grange-residence-featured-in-vogue-living");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-grange-residence-featured-in-vogue-living!./.cache/json/journal-grange-residence-featured-in-vogue-living.json
// module id = 495
// module chunks = 231608221292675